<template>
	<ShopView>
		<h1 class="mb-6 d-flex align-center">
			{{ $t('pageTitles.shop.brands') }}
		</h1>

		<BrandShopList></BrandShopList>
	</ShopView>
</template>

<script lang="ts">
	import {Vue, Component} from 'vue-property-decorator';
	import ShopView from "@/components/layout/ShopView.vue";
	import BrandShopList from "@/components/brand/shop/BrandShopList.vue";

	@Component({
		components: {BrandShopList, ShopView}
	})
	export default class Brands extends Vue {

	}
</script>

<style scoped lang="scss">

</style>
